import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AndroidAppInterface } from '../interfaces/android-app-interface';
import { AuthService } from './auth.service';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(
        public auth: AuthService, 
        public router: Router,
        public localSt: LocalStorageService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // Allow ext-patient SSO route without authentication (component handles SSO login)
        console.log('[AuthGuard] URL:', state.url, 'isAuthenticated:', this.auth.isAuthenticated());
        if (state.url.includes('/ext-patient/') && (state.url.includes('/domain/') || state.url.includes('/med-center/'))) {
            console.log('[AuthGuard] Bypassing auth for ext-patient SSO route');
            return true;
        }

        const mobileAppObj = (window as any).ANDROID_OBJ as AndroidAppInterface;
        if (this.auth.isAuthenticated()) {
            // Check if user must change password (skip for edit-profile route itself)
            if (this.auth.mustChangePassword() && !state.url.includes('edit-profile') && !mobileAppObj) {
                this.router.navigate(['/users/edit-profile']).then();
                return false;
            }
            if (route.data.permissions) {
                const userPermissions = this.auth.getPermissions();
                return route.data.permissions.some(
                    (permission: string) => userPermissions.indexOf(permission) !== -1);
            }
            return true;
        }
        this.localSt.store('redirectUrl', state.url);
        if (mobileAppObj) {
            this.router.navigate(['/screen/nurses-login']).then();
        } else {
            this.router.navigate(['login']).then();
        }
        return false;
    }
}
